import React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { userService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import { Button, InputText } from '../../../atoms'
import { Form } from '../../../molecules'
import SocialLoginButtons from '../../../organisms/SocialLoginButtons'

const FIELDS = {
  email: 'email',
  password: 'password',
}

interface IState {
  errors: any
}
interface IProps {
  user_type: 'guide' | 'agent' | 'guest' | 'admin'
}

class UserSessionsNew extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
    }
  }

  public handleUpdateForm = (errors, hasNoError) => {
    this.setState({
      errors: {
        ...this.state.errors,
        ...errors,
      },
    })
  }

  public handleSubmit = async (initialValues, values) => {
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const { redirectUrl } = await userService.signIn(
        {
          user: values,
          redirect_to: urlParams.get('redirect_to'),
        },
        this.props.user_type
      )
      this.setState({
        errors: {
          ...this.state.errors,
          login: null,
        },
      })
      location.href = redirectUrl
    } catch (error) {
      this.setState({
        errors: {
          ...this.state.errors,
          login: I18n.t('session.invalid_mail_or_password'),
        },
      })
    }
  }

  public render() {
    return (
      <UserSessionsNewWrapper>
        <div className="sessionTitle">
          {this.props.user_type === 'guest' && I18n.t('session.login_as_guest')}
          {this.props.user_type === 'guide' && I18n.t('session.login_as_guide')}
          {this.props.user_type === 'agent' && I18n.t('session.login_as_agent')}
          {this.props.user_type === 'admin' && I18n.t('session.login_as_admin')}
        </div>
        <Panel>
          <Form
            fields={FIELDS}
            handleSubmit={this.handleSubmit}
            handleUpdateForm={this.handleUpdateForm}
          >
            <FormItem>
              <InputText
                required={true}
                name="email"
                defaultValue=""
                label={I18n.t('generic.email')}
                placeholder="Email"
                error={this.state.errors.email}
              />
            </FormItem>
            <FormItem>
              <InputText
                required={true}
                password={true}
                name="password"
                defaultValue=""
                label={I18n.t('generic.password')}
                placeholder={I18n.t('generic.password')}
                error={this.state.errors.password}
              />
            </FormItem>
            <Buttons id="submit_login">
              {this.state.errors.login && <span className="error">{this.state.errors.login}</span>}
              <Button primary={true} backgroundColor={'#FF923E'}>
                {I18n.t('generic.login')}
              </Button>
              <p>
                <a href="/users/password/new">{I18n.t('session.forgot_password')}</a>
              </p>
              <p>
                <a href="/users/sign_up">{I18n.t('session.signup_page_for_guest')}</a>
              </p>
            </Buttons>
          </Form>
        </Panel>
        {this.props.user_type === 'guest' && (
          <SocialLoginWrapper>
            <SocialLoginButtons />
          </SocialLoginWrapper>
        )}
      </UserSessionsNewWrapper>
    )
  }
}

const UserSessionsNewWrapper = styled.main`
  padding-top: 36px;

  .error {
    color: ${constants.COLORS.cautionText};
    display: block;
    margin-bottom: 12px;
  }

  .sessionTitle {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 8px;
  }
`

const Buttons = styled.div`
  margin-top: 24px;
  text-align: center;

  > p {
    display: block;
    margin: 0 auto 16px;

    a {
      color: ${constants.COLORS.primary};
      text-decoration: underline;
    }
  }

  .Button {
    display: block;
    margin: 0 auto 16px;
    width: 160px;
    height: 40px;
    font-weight: bold;
    font-size: 16px;
  }
`

const Panel = styled.div`
  background-color: ${constants.COLORS.white};
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(21, 27, 38, 0.15);
  max-width: 600px;
  margin: 0 auto;
  padding: 24px;
`

const FormItem = styled.div`
  & + & {
    margin-top: 16px;
  }
`
const SocialLoginWrapper = styled.div`
  margin-bottom: 20px;
`

export default UserSessionsNew
